import { ChevronRight } from 'lucide-react';

import { clsx } from 'clsx';

import { ICON_DEFAULT } from '@shared/constants/colors';
import { BreadcrumbItemType } from '@shared/types/global';
import { ucFirst } from '@shared/utils/ucFirst/ucFirst';

import cls from './Breadcrumbs.module.scss';

type BreadcrumbsProps = {
  data: BreadcrumbItemType[];
  className?: string;
};

export const Breadcrumbs = ({ data, className }: BreadcrumbsProps) => {
  return (
    <div className={clsx(cls.wrap, className)}>
      <ul className={cls.list}>
        {data.map((item: BreadcrumbItemType, index: number) => {
          if (index === data.length - 1) {
            return (
              <li
                key={item.label}
                className={cls.item}
              >
                <div className={cls.label}>{ucFirst(item.label)}</div>
              </li>
            );
          }

          return (
            <li
              key={item.label}
              className={cls.item}
            >
              <a
                aria-label={`Перейти на страницу ${item.label}`}
                className={cls.link}
                href={item.url}
              >
                {ucFirst(item.label)}
              </a>
              <ChevronRight
                size={16}
                color={ICON_DEFAULT}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
};
